export const calculateDaysInBetween = (newDate: Date) => {
  const now = new Date();
  const diff = newDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const getSeverityColor = (severity: "error" | "warning" | "success") => {
  switch (severity) {
    case "error":
      return "#820000";
    case "warning":
      return "#E2AC00";
    case "success":
      return "#37C7AA";
  }
};

export const calculateOverdueColorHex = (dueDate: Date) => {
  const color = calculateOverdueColor(dueDate);
  return getSeverityColor(color);
};

export const calculateOverdueColor = (dueDate: Date) => {
  const diffDays = calculateDaysInBetween(dueDate);

  if (diffDays > 0) {
    return "success";
  } else if (diffDays > -31) {
    return "warning";
  } else {
    return "error";
  }
};

export const calculateOverdueColorByDays = (overdueDays: number) => {
  if (overdueDays === 0) {
    return "success";
  } else if (overdueDays < 31) {
    return "warning";
  } else {
    return "error";
  }
};

export const calculateColorHistoricPayment = (historicPaymentOnTime: number) => {
  const severity = historicPaymentOnTime >= 75 ? "success" : historicPaymentOnTime > 50 ? "warning" : "error";
  return getSeverityColor(severity);
};
